import { merchantApi } from '@/config/axios'
import type { Spu } from '@/api/mall/product/spu'

// ========== 商家端商品管理 API ==========

// 商品分页
export const getSpuPage = (params: any) => {
  return merchantApi.get({ url: '/merchant-api/product/spu/page', params })
}

// 商品详情
export const getSpu = (id: number) => {
  return merchantApi.get({ url: `/merchant-api/product/spu/get-detail?id=${id}` })
}

// 商品列表（批量查询）
export const getSpuDetailList = (ids: number[]) => {
  return merchantApi.get({ url: `/merchant-api/product/spu/list?spuIds=${ids}` })
}

// 创建商品
export const createSpu = (data: Spu) => {
  return merchantApi.post({ url: '/merchant-api/product/spu/create', data })
}

// 更新商品
export const updateSpu = (data: Spu) => {
  return merchantApi.put({ url: '/merchant-api/product/spu/update', data })
}

// 删除商品
export const deleteSpu = (id: number) => {
  return merchantApi.delete({ url: `/merchant-api/product/spu/delete?id=${id}` })
}

// 上架
export const putOnSale = (id: number) => {
  return merchantApi.put({ url: `/merchant-api/product/spu/put-on-sale?id=${id}` })
}

// 下架
export const putOffSale = (id: number) => {
  return merchantApi.put({ url: `/merchant-api/product/spu/put-off-sale?id=${id}` })
}

/** 更新商品状态（回收站 / 恢复仓库） */
export const updateStatus = (data: { id: number; status: number }) => {
  return merchantApi.put({ url: '/merchant-api/product/spu/update-status', data })
}

/** 本店商品 Tab 数量 */
export const getTabsCount = () => {
  return merchantApi.get({ url: '/merchant-api/product/spu/get-count' })
}

/** 导出本店商品（当前筛选） */
export const exportSpu = (params: any) => {
  return merchantApi.download({ url: '/merchant-api/product/spu/export-excel', params })
}

export interface MallImportProduct {
  id: number
  name: string
  picUrl: string
  price: number
  shopId: number
  deliveryTypes: number[]
}

export const getMallImportPage = (params: { name: string; pageNo: number; pageSize: number }) =>
  merchantApi.get({ url: '/merchant-api/product/spu/mall-import-page', params })

export const importMallProducts = (data: { spuIds: number[]; deliveryTemplateId?: number }) =>
  merchantApi.post({ url: '/merchant-api/product/spu/import-mall', data })

/** 导出本店可售清单（SKU） */
export const exportSaleableSpu = (params: any) => {
  return merchantApi.download({ url: '/merchant-api/product/spu/export-saleable-excel', params })
}

export interface ProductExcelImportFailure {
  rowIndex?: number
  bizKey?: string
  reason?: string
}

export interface ProductExcelImportResult {
  successCount: number
  failureCount: number
  failures?: ProductExcelImportFailure[]
}

/** 导入本店可售字段更新 */
export const importSaleableSpu = (formData: FormData) => {
  return merchantApi.upload<ProductExcelImportResult>({
    url: '/merchant-api/product/spu/import-saleable-excel',
    data: formData,
    timeout: 30 * 60 * 1000
  })
}

/** 下载新建商品导入模板 */
export const getCreateImportTemplate = () => {
  return merchantApi.download({ url: '/merchant-api/product/spu/get-create-import-template' })
}

/** 导入新建商品 */
export const importCreateSpu = (formData: FormData) => {
  return merchantApi.upload<ProductExcelImportResult>({
    url: '/merchant-api/product/spu/import-create-excel',
    data: formData,
    timeout: 30 * 60 * 1000
  })
}
